/*
 * File: MomentaryAssessment.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 22, 2025 at 4:11 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';
import { Card } from '../Card';


/**
 * Styles
 */

export const Wrapper = styled.div``;

export const AnswerCard = styled(Card)`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	cursor: pointer;
	padding: 12px 14px;
	gap: 10px;

	* {
		color: ${({ theme }) => theme.secondaryText};
	}
	svg {
		font-size: 1.0rem;
	}
`;

export const PositiveAnswerCard = styled(AnswerCard)`
	&.active {
		background-color: ${({ theme }) => theme.statusSuccessLighter};

		* {
			color: ${({ theme }) => theme.statusSuccessBase};
		}
	}
`;

export const NegativeAnswerCard = styled(AnswerCard)`
	&.active {
		background-color: ${({ theme }) => theme.neutralButton};

		* {
			color: ${({ theme }) => theme.secondaryText};
		}
	}
`;

export const NeutralAnswerCard = styled(AnswerCard)`
	&.active {
		background-color: ${({ theme }) => theme.statusInfoLighter};

		* {
			color: ${({ theme }) => theme.primaryText};
		}
	}
`;

export const Question = styled.div`
	& > p {
		margin: 0px 0px 10px;
	}
`;

export const Answers = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

export const InstructionsContainer = styled.div`
	margin: 0px 0px 10px;
`;

export const QuestionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const AssessmentsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;
